// src/components/bar/PickupCompleteScreen.js
import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import styles from './OrderPreparing.module.css';

const PickupCompleteScreen = ({ product, onBackToMenu }) => {
  const lottieSrc = `${process.env.PUBLIC_URL || ''}/images/Summer Cocktail.lottie`;

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* Lottieアニメーション（Summer Cocktail） */}
        <div className={styles.animationContainer}>
          <DotLottieReact
            src={lottieSrc}
            loop
            autoplay
            className={styles.lottieAnimation}
          />
        </div>

        <h2 className={styles.title}>
          受け取り完了しました！
        </h2>

        <p className={styles.description}>
          ごゆっくりお楽しみください。
        </p>

        {product && (
          <div className={styles.productInfo}>
            <p className={styles.productText}>
              お受け取り商品: <span className={styles.productName}>{product.name}</span>
            </p>
          </div>
        )}

        <div className={styles.buttonContainer}>
          <button
            onClick={onBackToMenu}
            className={styles.primaryButton}
          >
            メニューへ戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default PickupCompleteScreen;
